import { render } from "./PackageDiscountsListPanel.vue?vue&type=template&id=0750cb2f"
import script from "./PackageDiscountsListPanel.vue?vue&type=script&lang=js"
export * from "./PackageDiscountsListPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__